import React, { Component } from 'react'

export default class filters extends Component {
    render() {
        return (
            <svg className={this.props.className} onClick={this.props.onClick} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 3H2L10 12.46V19L14 21V12.46L22 3Z" stroke="#1063EA" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            
        )
    }
}
